import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { SupplierSelectComponent } from '@shared-feature/components/select/supplier-select/supplier-select.component';

@Component({
  selector: 'app-supplier-range',
  templateUrl: './supplier-range.component.html',
  styleUrls: [],
  standalone: false
})
export class SupplierRangeComponent {
  @ViewChild('toSelect') toSelect!: SupplierSelectComponent;
  @ViewChild('fromSelect') fromSelect!: SupplierSelectComponent;

  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
